<template>
  <div class="accountManage">
    <div>
      <el-button
        class="search-button"
        style="float: right"
        type="primary"
        @click="toAdd()"
        >新建账号</el-button
      >
    </div>
    <el-table class="data-table" :data="accountData" v-loading="loading">
      <el-table-column align="center" prop="id" label="ID"></el-table-column>
      <el-table-column
        align="center"
        prop="nick_name"
        label="账号名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="user_name"
        label="账号"
      ></el-table-column>
      <el-table-column align="center" prop="role" label="角色">
        <template slot-scope="scope">
          {{ role == 1 ? '管理员' : '老师' }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="role == 1"
        align="center"
        prop="teacher_count"
        label="子账号数量"
      ></el-table-column>
      <el-table-column
        v-if="role == 2"
        align="center"
        label="绑定班级"
        width="300"
      >
        <template slot-scope="scope">
          <div v-for="item in scope.row.classes" :key="item.no">
            {{ item.name }}，班级编号：{{ item.no }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="toEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            :type="scope.row.status == 0 ? 'primary' : 'danger'"
            size="mini"
            @click="toDisable(scope.row)"
            >{{ scope.row.status == 0 ? '启用' : '禁用' }}</el-button
          >
          <el-button type="danger" size="mini" @click="delOne(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="onaccountPageChange"
      :current-page="page"
      :page-size="10"
      layout="total, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <!-- 新建编辑账号 -->
    <el-dialog
      :title="isAdd ? '新建账号' : '编辑账号'"
      :visible.sync="addVisible"
      width="70%"
    >
      <el-row :gutter="10" class="detail-row">
        <el-col :span="4" style="text-align: center">账号名称：</el-col>
        <el-col :span="9" class="text-left">
          <el-input v-model="addInfo.name" placeholder=""></el-input>
        </el-col>
        <el-col :span="9" style="text-align: center">{{
          role == 1
            ? '*名称填写组织名称，如玉树小学'
            : '*名称格式：xx老师，例如：张三老师'
        }}</el-col>
      </el-row>
      <el-row :gutter="10" class="detail-row">
        <el-col :span="4" style="text-align: center">账号角色：</el-col>
        <el-col :span="9" class="text-left">
          {{ role == 1 ? '管理员' : '老师' }}
        </el-col>
      </el-row>
      <el-row :gutter="10" class="detail-row">
        <el-col :span="4" style="text-align: center">设置密码：</el-col>
        <el-col :span="9" class="text-left">
          <el-input
            v-model="addInfo.password"
            placeholder=""
            :disabled="!isAdd"
          ></el-input>
        </el-col>
      </el-row>
      <el-row v-if="role == 2" :gutter="10" class="detail-row">
        <el-col :span="4" style="text-align: center">绑定班级：</el-col>
        <el-col :span="9" class="text-left">
          <el-input
            v-model="addClassNo"
            placeholder="请输入要绑定的班级编号，点击添加"
          ></el-input>
        </el-col>
        <el-col :span="9" class="text-left">
          <el-button type="primary" @click="bindClass()">添加</el-button>
        </el-col>
      </el-row>
      <el-row v-if="role == 2" :gutter="10" class="detail-row">
        <el-col :span="4" style="text-align: center; opacity: 0"
          >绑定班级：</el-col
        >
        <el-col :span="12" class="text-left">
          <div class="flex">
            <div
              v-for="(item, index) in addInfo.classes"
              class="type-item"
              :key="item"
            >
              {{ item.name }}({{ item.no }})
              <div class="type-close" @click="delClass(index)"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button type="primary" @click="onAccountSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSchoolList,
  saveSchool,
  delSchool,
  getTeacherList,
  saveTeacher,
  getClassByNo,
  delTeacher,
} from '@/api/api.js'
export default {
  name: 'AccountManage',
  data: () => ({
    role: 1, // 1-超管 2-管理
    accountData: [],
    page: 1,
    total: 0,
    isAdd: true,
    addVisible: false,
    addClassNo: '',
    addInfo: {
      name: '',
      password: '',
      classes: [],
    },
    loading: false,
    roleDic: {
      school: '管理员',
    },
  }),
  mounted() {
    this.getData()
  },
  methods: {
    onaccountPageChange(e) {
      this.page = e
      this.getData()
    },
    getData() {
      let user = JSON.parse(localStorage.getItem('mykc-user'))
      console.log(user)
      if (!user.role) {
        // 超管
        this.role = 1
        getSchoolList(this.page).then((res) => {
          console.log(res)
          this.accountData = res.data.data.list
          this.total = res.data.data.total
        })
      } else {
        // 管理
        this.role = 2
        getTeacherList(this.page).then((res) => {
          this.accountData = res.data.data.list
          this.total = res.data.data.total
        })
      }
    },
    toAdd() {
      this.addVisible = true
      this.isAdd = true
      this.addInfo = {
        name: '',
        password: '',
        classes: [],
      }
      this.addClassNo = ''
    },
    toEdit(row) {
      this.addVisible = true
      this.isAdd = false
      this.addInfo.id = row.id
      this.addInfo.name = row.nick_name
      this.addInfo.password = ''
      if (this.role == 2) {
        this.addInfo.classes = row.classes || []
      }
    },
    delOne(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (this.role == 1) {
          delSchool(row.id).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: `删除成功！`,
                type: 'success',
              })
              this.getData()
            }
          })
        } else {
          delTeacher(row.id).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: `删除成功！`,
                type: 'success',
              })
              this.getData()
            }
          })
        }
      })
    },
    // 禁用启用
    toDisable(row) {
      this.$confirm(`确认${row.status == 0 ? '启用' : '禁用'}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (this.role == 1) {
          saveSchool({
            id: row.id,
            status: row.status == 0 ? 1 : 0,
          }).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: `${row.status == 0 ? '启用' : '禁用'}成功！`,
                type: 'success',
              })
              this.getData()
            }
          })
        } else {
          saveTeacher({ id: row.id, status: row.status == 0 ? 1 : 0 }).then(
            (res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: `${row.status == 0 ? '启用' : '禁用'}成功！`,
                  type: 'success',
                })
                this.getData()
              }
            }
          )
        }
      })
    },
    // 添加绑定班级
    bindClass() {
      if (!this.addClassNo) {
        this.$message({
          message: '请输入班级编号！',
          type: 'warning',
        })
        return
      }
      getClassByNo(this.addClassNo).then((res) => {
        console.log(res.data)
        if (!res.data.data) {
          this.$message({
            message: '请输入正确的班级编号！',
            type: 'warning',
          })
        } else {
          let repeat = false
          this.addInfo.classes.forEach((item) => {
            if (item.id == res.data.data.id) {
              repeat = true
            }
          })
          if (repeat) {
            this.$message({
              message: '请勿重复添加！',
              type: 'warning',
            })
          } else {
            this.addInfo.classes.push(res.data.data)
          }
        }
      })
    },
    // 删除绑定班级
    delClass(index) {
      let classes = this.addInfo.classes
      classes.splice(index, 1)
      this.addInfo.classes = classes
    },
    // 账号保存
    onAccountSave() {
      if (!this.addInfo.name) {
        this.$message({
          message: '请输入账号名称！',
          type: 'warning',
        })
        return
      }
      if (!this.addInfo.password && this.isAdd) {
        this.$message({
          message: '请输入密码！',
          type: 'warning',
        })
        return
      }
      // if (this.role == 2 && this.addInfo.classes.length == 0) {
      //   this.$message({
      //     message: "请添加班级！",
      //     type: "warning",
      //   });
      //   return;
      // }
      if (this.role == 1) {
        // 添加编辑学校管理员
        let params = {
          nick_name: this.addInfo.name,
          // password: this.addInfo.password,
        }
        if (this.addInfo.password) {
          params.password = this.addInfo.password
        }
        if (!this.isAdd) {
          params.id = this.addInfo.id
        }
        saveSchool(params).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: `${this.isAdd ? '新增' : '修改'}成功！`,
              type: 'success',
            })
            this.addVisible = false
            this.getData()
          }
        })
      } else {
        // 添加编辑老师
        let classes_id = []
        this.addInfo.classes.forEach((item) => {
          classes_id.push(item.id)
        })
        let params = {
          nick_name: this.addInfo.name,
          // password: this.addInfo.password,
        }
        if (this.addInfo.password) {
          params.password = this.addInfo.password
        }
        params.classes_id = classes_id
        if (!this.isAdd) {
          params.id = this.addInfo.id
        }
        saveTeacher(params).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: `${this.isAdd ? '新增' : '修改'}成功！`,
              type: 'success',
            })
            this.addVisible = false
            this.getData()
          }
        })
      }
    },
  },
}
</script>

<style lang="less">
.accountManage {
  .hide {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 7px;
      left: -2px;
      width: 20px;
      height: 1px;
      background: #333;
      transform: rotate(-45deg);
    }
  }
  .detail-row {
    line-height: 40px;
    margin-bottom: 20px;
  }
  .flex {
    display: flex;
    flex-flow: row wrap;
  }
  .type-item {
    position: relative;
    height: 40px;
    padding: 0 15px;
    margin-right: 10px;
    margin-bottom: 10px;
    border: 1px solid #ddd;
    border-radius: 20px;
    .type-close {
      position: absolute;
      top: -10px;
      right: -10px;
      width: 20px;
      height: 20px;
      border-radius: 10px;
      border: 1px solid #ccc;
      background-color: #fff;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 15px;
        height: 2px;
        background-color: #ccc;
        cursor: pointer;
        transform: translate(-50%, -50%) rotate(45deg);
      }
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 15px;
        height: 2px;
        background-color: #ccc;
        cursor: pointer;
        transform: translate(-50%, -50%) rotate(-45deg);
      }
    }
  }
}
</style>
